export default __webpack_public_path__ + "static/media/shantal-colores.73ae3870.png";